export default class QueryLink {
  constructor(selector) {
    this._queryLinks = document.querySelectorAll(selector);

    console.log(this._queryLinks);

    this._setEventListeners();
  }

  _setEventListeners() {
    this._queryLinks.forEach((anchorEl) => {
      anchorEl.addEventListener("click", (e) => {
        e.preventDefault();
        const currentURL = new URL(document.location);

        currentURL.searchParams.set(
          "_equipment_type",
          currentURL.searchParams.get("_equipment_type")
            ? `${anchorEl.dataset.slug},${currentURL.searchParams.get(
                "_equipment_type"
              )}`
            : anchorEl.dataset.slug
        );

        document.location.href = currentURL.href;
      });
    });
  }
}

window.f1 = () => false;
